import {useRouter} from '@/hooks';
import {appleLogin} from '@front/api/sso';
import {DEFAULT_PORTAL} from '@/glue';
import {domainEvent, useAppAction, useAppleQuery} from '@front/hooks';
import {merge} from 'lodash-es';

const { routerTo } = useRouter();
const { query, cleanQuery } = useAppleQuery();
const failRoute = '/ExternalLoginVerify';
const { isRegister } = useAppAction();
// apple
document.addEventListener('AppleIDSignInOnSuccess', event => {
  // Handle successful response.
  const { id_token } = event.detail.authorization;
  const data = { provider: 'apple', token: id_token };
    merge(data, query.value);
    appleLogin(data).then(r => {
      if (r.success) {
          if(r.data.quickLoginAction === 'REGISTER'){
              
              
              window.fbq?.('track', 'CompleteRegistration', {
                  content_name: 'registration',
                  contents: { channel: 'apple', agent: data.a ?? undefined },
                  status: true,
              });
              routerTo(DEFAULT_PORTAL);
          }else{
              domainEvent.dispatch('LOGIN');
              routerTo(DEFAULT_PORTAL);
          }
      } else {
        routerTo(failRoute + `?errorCode=${r.errorCode}`);
      }
    }).finally(fin =>{ cleanQuery(); });
});

document.addEventListener('AppleIDSignInOnFailure', event => {
  // Handle error.
  // cleanQuery();
  // console.log(10, event.detail.error);
});
